import { TrendingUp } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { VendorPriceChangesQueuePage } from './pages/VendorPriceChangesQueuePage'
import { VendorPriceChangeDetailPage } from './pages/VendorPriceChangeDetailPage'
import { VendorPriceChangesHistoryPage } from './pages/VendorPriceChangesHistoryPage'
import { UpcomingPriceChangesPage } from './pages/UpcomingPriceChangesPage'

/**
 * Sprint 37 — Vendor Cost / Margin-Protection System.
 *
 * A review QUEUE with an approval workflow (open → reviewing →
 * resolved/dismissed) — structurally like sales-inbox / cofa-pipeline,
 * not like the stateless `margins` report. Deliberately a separate
 * module rather than bolted onto Margins (see the Sprint 37 plan for
 * the rationale): Margins is a computed-on-demand snapshot with no
 * workflow state; this module IS the workflow.
 */
export default defineModule({
  id: 'vendor-price-changes',
  name: 'Vendor Price Changes',
  shortName: 'Price Changes',
  icon: TrendingUp,
  navSection: 'purchasing',
  navOrder: 21,
  urlNamespace: '/vendor-price-changes',
  routes: [
    { path: '/', element: VendorPriceChangesQueuePage, label: 'Vendor Price Changes' },
    { path: '/history', element: VendorPriceChangesHistoryPage, label: 'History' },
    { path: '/upcoming', element: UpcomingPriceChangesPage, label: 'Upcoming' },
    { path: '/$flagId', element: VendorPriceChangeDetailPage, label: 'Flag detail' },
  ],
  permissions: ['admin', 'operations', 'purchasing'],
  densityDefault: 'compact',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g v p',

  commandPaletteEntries: [
    {
      label: 'Go to Vendor Price Changes',
      keywords: [
        'vendor', 'price', 'cost', 'increase', 'margin', 'protection',
        'pricelist', 'flag', 'review', 'purchasing',
      ],
      path: '/',
      group: 'modules',
      shortcut: 'g v p',
    },
    {
      label: 'Upcoming vendor price changes',
      keywords: ['vendor', 'price', 'scheduled', 'upcoming', 'effective', 'future', 'cost', 'hallstar'],
      path: '/upcoming',
      group: 'modules',
    },
  ],

  consumesServices: ['odoo-search'],
})
